import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/views/layout'
import mbLayout from '@/views/layout/mbLayout'

import pc from './modules/pc.js'
import mobile from './modules/mobile.js'
Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function(location) {
  return originalPush.call(this, location).catch((err) => err)
}
// pc端路由数据
const routesP = [
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [
      ...pc
    ]
  },

  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: ':path*',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '*',
    component: () => import('@/views/redirect/404')
  },
  {
    path: '/403',
    name: '403',
    component: () => import('@/views/redirect/403')
  },
  // 页面刷新 必须保留
  {
    path: '/refresh',
    name: 'refresh',
    component: {
      beforeRouteEnter(to, from, next) {
        next((vm) => {
          vm.$router.replace(from.fullPath)
        })
      },
      render: (h) => h()
    }
  },
 
  {
    path: '/login_wht',
    name: 'login_wht',
    component: () => import('@/views/login_wht')
  },

]

// 移动端路由数据
const routesM = [
    {
      path: '/',
      component: mbLayout,
      redirect: {
        name: 'mb_home'
      },
      children: [
        ...mobile
      ]
    },
    // {
    //   path: '/login',
    //   name: "login",
    //   component: loginLayout,
    //   meta: {
    //     title: '登陆',
    //     isHomePage: false,
    //   },
    //   redirect: {
    //     name: 'login'
    //   },
    //   children: [
    //     {
    //       path: "",
    //       name: "login",
    //       target:true,
    //       meta: {
    //         title: '登陆',
    //         hiddenNode: true,
    //         trrget: "_blank",
    //       },
    //       component: () => import('@/views/login') 
    //     }
    //   ]
    // },
    {
      path: '/redirect',
      component: Layout,
      hidden: true,
      children: [
        {
          path: ':path*',
          component: () => import('@/views/redirect/index')
        }
      ]
    },
    {
      path: '*',
      component: () => import('@/views/redirect/404')
    },
    {
      path: '/403',
      name: '403',
      component: () => import('@/views/redirect/403')
    },
    // 页面刷新 必须保留
    {
      path: '/refresh',
      name: 'refresh',
      component: {
        beforeRouteEnter(to, from, next) {
          next((vm) => {
            vm.$router.replace(from.fullPath)
          })
        },
        render: (h) => h()
      }
    },
   
  
  
]
  

var routes = [];

//使用userAgent判断
function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};
// 使用媒体查询判断
function isWidth() {
  return window.matchMedia("(max-width: 767px)").matches;
}
function isIpad(){    
  return (navigator.userAgent.match(/(iPad)/) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1))
}


// console.log("判断移动端", isWidth(),isMobile(),isIpad())
if (isWidth() || isMobile() || isIpad()) {
  routes = routesM
  console.log("移动端")
} else {
  routes = routesP
  console.log("pc端")
}

const router = new VueRouter({
  mode: 'history',
  // mode: "hash",
  // base: process.env.BASE_URL,
  base: '/',
  routes,
  // 添加以下代码
  scrollBehavior(to,from,savedPosition){
    if(savedPosition){
      return savedPosition;
    }else{
      return {x:0,y:0}
    }
  },

})

// ========== 跨端路由自动跳转 ==========

// 移动端路由 → PC 端路由 的映射
const mb2pc = {
    mb_home: 'home',
    mbProduct: 'productList',
    mbHardware: 'productHardware',
    mbCloud: 'weldCloud',
    mbSoftware: 'productSoftware',
    mbSoftwareApp: 'productSoftwareApp',
    mbSolutionList: 'solutionList',
    mbSolutionDetail: 'solutionDetail',
    mbCase: 'caseList',
    mbNews: 'news',
    mbNewsDetail: 'newsDetail',
    mbResourceDownload: 'resourceList',
    mbIndustry: 'industry',
    mbCertificate: 'weldCertificate',
    mbVideo: 'videoList',
    mbAbout: 'about',
    mbSystem: 'system',
}

// PC 端路由 → 移动端路由 的映射
const pc2mb = {}
Object.keys(mb2pc).forEach(mb => { pc2mb[mb2pc[mb]] = mb })

// ============================================================
// 3. 路由前置守卫：核心跳转逻辑
// ============================================================
router.beforeEach((to, from, next) => {
    // 3.1 判断当前设备类型
    const currentIsMobile = isWidth() || isMobile() || isIpad()
     // 3.2 获取目标路由名称（去掉开头的 /）
    const targetPath = to.path.replace(/^\//, '')  // 去掉开头的 /

    // ============================================================
    // 场景一：移动端访问
    // 用户使用手机/平板访问时，如果访问的是 PC 端路由，
    // 自动跳转到对应的移动端路由
    // ============================================================
    // if (currentIsMobile) {
    //     // 当前是移动端浏览器 → 如果访问的是 PC 端路由，跳转到移动端对应路由
    //     if (pc2mb[targetPath]) {
    //         // 例如：访问 '/home' → 跳转到 '/mb_home'
    //         next('/' + pc2mb[targetPath])
    //         return
    //     }
    // } else {
    //     // 当前是 PC 端浏览器 → 如果访问的是移动端路由，跳转到 PC 端对应路由
    //     if (mb2pc[targetPath]) {
    //       // 例如：访问 '/mb_home' → 跳转到 '/home'
    //         next('/' + mb2pc[targetPath])
    //         return
    //     }
    // }
    if (currentIsMobile) {
          if (pc2mb[targetPath]) {
              next({ path: '/' + pc2mb[targetPath], query: to.query })  // 带上 query
              return
          }
      } else {
          if (mb2pc[targetPath]) {
              next({ path: '/' + mb2pc[targetPath], query: to.query })   // 带上 query
              return
          }
      }
    // ============================================================
    // 3.3 无需跳转的情况
    // - 访问的路由在映射表中不存在
    // - 当前设备类型与路由类型匹配
    // 直接放行
    // ============================================================

    next()
})


export default router
